import { getAxiosClient } from "../../axios-client";
import { PutServicesUpdateRequestBody, PutServicesUpdateResponse } from "./types";

const axiosClient = getAxiosClient();
export const putServicesUpdate = async (body: PutServicesUpdateRequestBody) => {
    return await axiosClient.ax.put<PutServicesUpdateResponse>("/WarehouseFacilities/WarehouseServicesUpdate", body);
};
